import { designTokens } from '../../design-system';

// 구성원·관리자 홈에서 공유하는 업무별 강조색은 Home feature가 의미를 소유한다.
export const homeServiceThemes = {
  profile: { accent: designTokens.color.action, tint: designTokens.color.actionSoft },
  tasks: { accent: designTokens.color.successDark, tint: designTokens.color.successSoft },
  workflow: { accent: designTokens.color.action, tint: designTokens.color.actionSoft },
  absence: { accent: designTokens.color.infoDark, tint: designTokens.color.infoSoft },
  documents: { accent: designTokens.color.warningAccentText, tint: designTokens.color.warningSoft },
  directory: { accent: designTokens.color.action, tint: designTokens.color.actionSoft },
  recruiting: { accent: designTokens.color.action, tint: designTokens.color.actionSoft },
  settings: { accent: designTokens.color.secondaryText, tint: designTokens.color.subtleSurface },
} as const;
